import React, { forwardRef } from 'react';
import { cn } from '../../lib/cn';

export const Table = forwardRef(function Table({ className, wrapperClassName, children, ...props }, ref) {
  return (
    <div
      className={cn(
        'w-full overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-700',
        wrapperClassName
      )}
    >
      <table
        ref={ref}
        className={cn('w-full min-w-[min(100%,640px)] border-collapse text-left text-sm text-slate-800 dark:text-slate-200', className)}
        {...props}
      >
        {children}
      </table>
    </div>
  );
});

export const THead = forwardRef(function THead({ className, ...props }, ref) {
  return (
    <thead
      ref={ref}
      className={cn(
        'border-b border-slate-200 bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-600',
        'dark:border-slate-700 dark:bg-slate-800/80 dark:text-slate-300',
        className
      )}
      {...props}
    />
  );
});

export const TBody = forwardRef(function TBody({ className, ...props }, ref) {
  return <tbody ref={ref} className={cn('divide-y divide-slate-200 dark:divide-slate-700', className)} {...props} />;
});

export const Tr = forwardRef(function Tr({ className, ...props }, ref) {
  return (
    <tr
      ref={ref}
      className={cn('transition-colors hover:bg-slate-50/80 dark:hover:bg-slate-800/50', className)}
      {...props}
    />
  );
});

export const Th = forwardRef(function Th({ className, ...props }, ref) {
  return (
    <th
      ref={ref}
      className={cn('whitespace-nowrap px-3 py-2.5 text-left font-semibold sm:px-4', className)}
      {...props}
    />
  );
});

export const Td = forwardRef(function Td({ className, ...props }, ref) {
  return <td ref={ref} className={cn('px-3 py-2.5 sm:px-4', className)} {...props} />;
});
